<template>
  <v-card flat>
    <v-form
      ref="form"
      v-model="valid"
      class="login--form"
      lazy-validation
      @keydown.native.enter="validate"
    >
      <v-card-text>
        <div class="row">
          <v-col
            v-if="errMsg"
            cols="12"
            class="login-errMsg"
          >
            Login failed. Please try again.
          </v-col>
        </div>
        <div align="left">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            placeholder="Email address"
            pt="5"
            required
            tabindex="1"
            class="login-email-input login-input"
            :append-outer-icon="
              emailErrCnt == 0 ? '' : isValidatedEmail ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle'
            "
            @blur="isValidatedEmailMethod"
          />
          <v-spacer />
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            hint=""
            placeholder="Password"
            required
            tabindex="1"
            class="login-pass-input login-input"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :append-outer-icon="
              pwdErrCnt == 0 ? '' : isValidatedPass ? 'mdi-checkbox-marked-circle' : 'mdi-alert-circle'
            "
            @blur="isValidatedPassMethod"
            @click:append="showPassword = !showPassword"
          />
        </div>
        <div class="remember-forgot">
          <v-btn
            :loading="loading"
            :disabled="!valid"
            class="login-btn"
            height="42"
            tabindex="1"
            @click="validate"
          >
            Sign In
          </v-btn>
          <div>
            <router-link
              class="forgot-link"
              to="/resetpassword"
            >
              Forgot password?
            </router-link>
          </div>
        </div>
      </v-card-text>
      <v-spacer />
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      showPassword: false,
      valid: true,
      errMsg: false,
      emailErrCnt: 0,
      pwdErrCnt: 0,
      email: '',
      password: '',
      color_checkbox: true,
      passwordRules: [
        value => !!value || 'Password is required',
        v => v.length >= 6 || 'Min 6 characters'
      ],
      nameRules: [(value) => !!value || 'This field is required'],
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => /.+@.+\..+/.test(v) || 'Email must be valid'
      ]
    }
  },
  computed: {
    loading() {
      return this.$store.getters.loading
    },
    errors() {
      return this.$store.getters.error
    },
    isError() {
      if (this.$store.getters.error) {
        return true
      } else {
        return false
      }
    },
    isValidatedEmail() {
      const validRegEx = /\S+@\S+\.\S+/
      return this.email !== null && validRegEx.test(this.email)
    },
    isValidatedPass() {
      const validRegEx = /^.{1,}$/
      return this.password !== null && validRegEx.test(this.password)
    }
  },
  watch: {
    isValidatedEmail: {
      deep: true,
      handler: function (newVal) {
        this.emailErrCnt++
      }
    },
    isValidatedPass: {
      deep: true,
      handler: function (newVal) {
        this.pwdErrCnt++
      }
    }
  },
  mounted() {
    setInterval(this.removeErrors, 5000)
  },

  methods: {
    isValidatedEmailMethod() {
      const validRegEx = /\S+@\S+\.\S+/
      if (this.email === '' && !validRegEx.test(this.email)) {
        this.emailErrCnt++
      }
    },
    isValidatedPassMethod() {
      const validRegEx = /^.{1,}$/
      if (this.password === '' && !validRegEx.test(this.password)) {
        this.pwdErrCnt = 1
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.login()
      }
    },
    changecolor() {
      this.color_checkbox = !this.color_checkbox
    },
    async login() {
      await this.$store
        .dispatch('user/login', {
          email: this.email,
          password: this.password
        })
        .then((res) => {
          this.errMsg = (res === undefined)
          this.$store.dispatch('closeSubmitFormErrorPopup')
        })
    },
    removeErrors() {
      this.$store.dispatch('user/removeErrors')
    }
  }
}
</script>

<style scoped lang="scss">
.forgot-link {
  margin-top: 21px;
  color: #7671bd !important;
  font-weight: 500;
  font-size: 15px;
  font-family: 'Source Sans 3', sans-serif;
  text-decoration: none;
  white-space: nowrap;
  text-align: right;

  &:hover {
    text-decoration: underline;
  }
  @media screen and (min-width: 960px) {
    font-size: 18px;
  }
  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
}

.remember-forgot {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 30px 0;

  @media screen and (min-width: 468px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media screen and (min-width: 960px) {
    margin-right: 20px;
  }
}

.remember-label >>> .v-input__slot i {
  font-size: 20px;
  font-family: 'Source Sans 3', sans-serif;
}

.btn-block {
  padding: 0 16px !important;
}
.login-input::placeholder {
  color: #333 !important;
}
.login-input {
  font-size: 1.1rem !important;
}

.label-field {
  font-size: 1.2rem !important;
}
.login--form {
  font-size: 1.2rem !important;
  color: #fff !important;
  font-family: 'Source Sans 3', sans-serif;
  min-width: 280px;
}
.subtitle-2 {
  margin-top: 20px;
  text-decoration: none;
  color: #413967;
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 700;
  font-size: 1.2rem !important;
}

.v-input__slot label {
  font-size: 1.2rem !important;
  color: #413967 !important;
  font-weight: 600;
  font-family: 'Source Sans 3', sans-serif;
  padding-left: 10px;
}
.v-btn__content {
  color: #fff !important;
}
.login-errMsg {
  padding: 0;
  font-size: 18px;
  color: #ff5252;
  text-align: center;
  margin-bottom: 20px;
}
.error-alert {
  background-color: orange !important;
  color: white;
}
.error-alert i {
  border: 1px solid white;
}
.login-email-input,
.login-pass-input {
  padding-top: 0;
}
.login--form >>> .v-messages__message {
  color: #ff5252;
  font-size: 13px;
}
.v-icon.v-icon.v-icon--link {
  color: #9a97a7 !important;
}
.v-text-field > .v-input__control > .v-input__slot:after {
  border-color: #7671bd !important;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  color: #dfddec !important;
}
.login-btn {
  width: 160px;
  background-color: #7671bd !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 1rem !important;
  font-weight: 500;
  transition: 0.3s;
}
.login-btn:hover {
  background-color: #534f8c !important;
  color: #ffffff !important;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #584c8e !important;
}
@media screen and (max-width: 468px) {
  .login-btn {
    width: 100%;
  }
}
</style>
